/*
Monotype Foundry Platform API
Version 1.0.0

Definition: MfpNumbersRequest

Properties:
  modules: array
  startDate: string
  endDate: string
  foundryId: string
  unverifiedUsersLimit: number
  unverifiedUsersOffset: number
*/

var MfpNumbersRequest = (function () {
  function validateMfpNumbersRequest (arg) {
    // Validate modules
    if (arg.modules && !(Array.isArray(arg.modules))) {
      throw new Error('MfpNumbersRequest.modules: Wrong type: Got \'' + (typeof arg.modules) + '\', but expected: \'array\'')
    }
    // Validate startDate
    if (arg.startDate && !(typeof arg.startDate === 'string')) {
      throw new Error('MfpNumbersRequest.startDate: Wrong type: Got \'' + (typeof arg.startDate) + '\', but expected: \'string\'')
    }
    // Validate endDate
    if (arg.endDate && !(typeof arg.endDate === 'string')) {
      throw new Error('MfpNumbersRequest.endDate: Wrong type: Got \'' + (typeof arg.endDate) + '\', but expected: \'string\'')
    }
    // Validate foundryId
    if (arg.foundryId && !(typeof arg.foundryId === 'string')) {
      throw new Error('MfpNumbersRequest.foundryId: Wrong type: Got \'' + (typeof arg.foundryId) + '\', but expected: \'string\'')
    }
    // Validate unverifiedUsersLimit
    if (arg.unverifiedUsersLimit && !(typeof arg.unverifiedUsersLimit === 'number')) {
      throw new Error('MfpNumbersRequest.unverifiedUsersLimit: Wrong type: Got \'' + (typeof arg.unverifiedUsersLimit) + '\', but expected: \'number\'')
    }
    // Validate unverifiedUsersOffset
    if (arg.unverifiedUsersOffset && !(typeof arg.unverifiedUsersOffset === 'number')) {
      throw new Error('MfpNumbersRequest.unverifiedUsersOffset: Wrong type: Got \'' + (typeof arg.unverifiedUsersOffset) + '\', but expected: \'number\'')
    }
  }
  function buildMfpNumbersRequest (arg) {
    var MfpNumbersRequest = arg
    // Complete modules
    // Expected Type: array
    MfpNumbersRequest.modules = MfpNumbersRequest.modules || []
    // Complete startDate
    // Expected Type: string
    MfpNumbersRequest.startDate = MfpNumbersRequest.startDate || ''
    // Complete endDate
    // Expected Type: string
    MfpNumbersRequest.endDate = MfpNumbersRequest.endDate || ''
    // Complete foundryId
    // Expected Type: string
    MfpNumbersRequest.foundryId = MfpNumbersRequest.foundryId || ''
    // Complete unverifiedUsersLimit
    // Expected Type: number
    MfpNumbersRequest.unverifiedUsersLimit = MfpNumbersRequest.unverifiedUsersLimit || 0
    // Complete unverifiedUsersOffset
    // Expected Type: number
    MfpNumbersRequest.unverifiedUsersOffset = MfpNumbersRequest.unverifiedUsersOffset || 0
    return MfpNumbersRequest
  }
  return {
    validate: validateMfpNumbersRequest,
    build: buildMfpNumbersRequest
  }
})()

module.exports = MfpNumbersRequest
